<template>
	<div id="home">
		<div class="top">
			<div class="logo"></div>
			<div class="top_info">
				<div>
					<p>智慧医院·数字化糖尿病管理解决⽅案</p>
					<p>Wisdom Hospital · Digital Management Diabetes Solution</p>
				</div>
				<div>028-86021557</div>
			</div>
		</div>
		<div class="container">
			<div class="main-part"></div>
		</div>
		<div class="container grey-bg">
			<div class="content-box">
				<div class="content-column">
					<p>集成、安全的数字化解决⽅案</p>
					<p>数据洞察，个体化诊疗，提⾼医疗决策精准性</p>
				</div>
				<div class="content-row row1">
					<div>
						<img src="../../assets/events/dongmai/connect.png" />
						<div>数据连接</div>
					</div>
					<div>
						<img src="../../assets/events/dongmai/share.png" />
						<div>数据共享</div>
					</div>
					<div>
						<img src="../../assets/events/dongmai/message.png" />
						<div>数据洞察</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container white-bg">
			<div class="content-box">
				<div class="content-column">
					<p>塑造⾼效糖尿病管理流程</p>
					<p>花更少的时间上传糖尿病数据，花更多的时间与患者合作</p>
				</div>
				<div class="content-row row2" style="margin-top:80px">
					<div>
						<img src="../../assets/events/dongmai/mac.png" />
					</div>
					<div>
						<img src="../../assets/events/dongmai/report.png" />
					</div>
				</div>
			</div>
		</div>
		<div class="container grey-bg">
			<div class="content-box">
				<div class="content-column">
					<p>可衡量的管理效果</p>
					<p>医护⼈员通过睿控糖管理系统对糖尿病患者进⾏管理</p>
				</div>
				<div class="content-row row3">
					<div>
						<div style="float:left">
							<img src="../../assets/events/dongmai/point.png" />
							<div>平均⾎糖降低</div>
							<p>
								<span>3</span>个⽉降低
								<span>15%</span>
								<br />
								<span>6</span>个⽉降低
								<span>21%</span>
								<br />
								<span>12</span>个⽉降低
								<span>29%</span>
							</p>
						</div>
					</div>
					<div>
						<div>
							<img src="../../assets/events/dongmai/correct.png" />
							<div>达标⾎糖⽐例增加</div>
							<p>
								<span>3</span>个⽉增加
								<span>26%</span>
								<br />
								<span>6</span>个⽉增加
								<span>43%</span>
								<br />
								<span>12</span>个⽉增加
								<span>50%</span>
							</p>
						</div>
					</div>
					<div>
						<div style="float:right">
							<img src="../../assets/events/dongmai/down.png" />
							<div>⾎糖波动减少</div>
							<p>
								<span>3</span>个⽉减少
								<span>29%</span>
								<br />
								<span>6</span>个⽉减少
								<span>56%</span>
								<br />
								<span>12</span>个⽉减少
								<span>62%</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container white-bg">
			<div class="content-box">
				<div class="content-column">
					<p>远程照护与患者自我管理支持</p>
					<p>医患共享，为患者⽇常决策提供有价值的反馈与⽀持</p>
				</div>
				<div class="content-row row2" style="margin-top:80px">
					<div>
						<img src="../../assets/events/dongmai/mobile.png" style="width:898px;height:658px" />
					</div>
				</div>
			</div>
		</div>
		<div class="container aboutUS">
			<div class="content-box">
				<div class="_info">
					<div>
						<img src="../../assets/home_logo2.png" />
					</div>
					<div>
						<p>用户指南</p>
						<a href="#">如何报名</a>
						<a href="#">如何使用</a>
						<a href="#">如何下载</a>
						<a href="#">常见问题</a>
					</div>
					<div>
						<p>联系我们</p>
						<a href="#">官方微信</a>
						<a href="#">新浪微博</a>
						<a href="#">诚聘英才</a>
						<a href="#">意见反馈</a>
					</div>
					<div>
<!--						<canvas style="width:100px;height:100px;" ref="canvas_bottom"></canvas>-->
            <img style="width:100px;height:100px;" src="../../assets/downloadQrcode.png"/>
						<p>扫一扫，下载APP</p>
					</div>
				</div>
        <p style="font-size: 14px">Copyright 2014 - {{year}} 四川华诺智胜健康科技有限公司版权所有 &nbsp;|&nbsp; 互联网药品信息服务资格证书编号:(川)-非经营性-2020-0003</p>
				<p style="font-size: 14px;display: flex; align-items: center; justify-content: center">
          <a :href="`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${cqBeiAnHao}`" target="_blank" style="margin-right: 10px">
            <img src="@/assets/beiantubiao.png"/>
            <span>渝公网安备 {{cqBeiAnHao}}号</span>
          </a>
          <a href="http://beian.miit.gov.cn" target="_blank" style="margin-left: 10px">{{ beiAnHao }}</a>
				</p>


			</div>
		</div>
	</div>
</template>
<script>
	import QRCode from "qrcode";
	import apiService from "../../api.path.js";
	export default {
		data() {
			return {
				year: new Date().getFullYear(),
				show: true,
        cqBeiAnHao: '50011202503930',
        beiAnHao: '蜀ICP备19010891号-1',
				openURL(platform) {
					var url = apiService.api + "/api/services/app/Home/GetDownloadUrlAsync";
					url += platform ? "?agentType=" + platform : "";
					this.$http.get(url).then(res => {
						if (res.body.success) {
							window.location.href = res.body.result;
							window.console.log(res);
						}
					});
				}
			};
		},
		name: "home",
		mounted() {
			// QRCode.toCanvas(this.$refs.canvas_top, window.location.origin);

      this.setBeiAnHao()
			QRCode.toCanvas(this.$refs.canvas_bottom, window.location.origin);
		},
		methods: {
			download(type) {
				this.openURL(type);
			},
      /**
       * 根据当前域名设置备案号
       */
      setBeiAnHao () {
        if (window.location.href.indexOf("hn-ihealth.com") !== -1) {
          this.cqBeiAnHao = "50011202503930";
          this.beiAnHao = "蜀ICP备19010891号-1";
        } else if (window.location.href.indexOf("sugrq.com") !== -1) {
          this.cqBeiAnHao = "50011202503931";
          this.beiAnHao = "蜀ICP备19010891号-2";
        } else if (window.location.href.indexOf("refresh-now.com") !== -1) {
          this.cqBeiAnHao = "50011202503932";
          this.beiAnHao = "蜀ICP备19010891号-3";
        }
      }
		}
	};
</script>

<style lang="scss">
	#home {
		width: 100%;

		p {
			margin: 0;
		}

		.container {
			display: flex;
			//   min-width: 1020px;
			width: 100%;
			overflow: hidden;
			text-align: center;
			&:nth-of-type(2) {
				position: relative;
				background: url("../../assets/events/dongmai/banner.png") no-repeat 50%;
				// background-size: 100% 100%;
				// background-attachment: fixed;

				/* 让背景图基于容器大小伸缩 */
				background-size: cover;
				background-position-y: top;
			}
			.content-box {
				padding: 160px 0;
				.content-row {
					display: flex;
					flex-flow: row;
				}
				.content-column {
					display: flex;
					flex-flow: column;
				}
				.row1 > div {
					margin: 100px 100px 0 100px;
					font-size: 25px;
					color: #1f3864;
					img {
						width: 200px;
						height: 200px;
					}
				}
				.row3 {
					text-align: center;
					> div {
						text-align: center;
						margin: 100px auto 0;
						width: 33.3%;
						font-size: 30px;

						color: #1190ff;
						> div {
							margin: 0 auto;
							display: block;
							text-align: center;
							width: 240px;
							img {
								width: 150px;
								height: 150px;
								padding-bottom: 40px;
							}
							p {
								padding-top: 46px;
								font-size: 25px;
								line-height: 240%;
								color: #1f3864;
								text-align: center;
								// span {
								// 	color: #00aaff;
								// }
							}
						}
					}
				}
			}
		}

		.grey-bg,
		.white-bg {
			.content-box {
				justify-content: space-between;
				& > div {
					box-sizing: border-box;
				}
			}

			p {
				width: 100%;
				font-size: 30px;
				font-weight: normal;
				font-stretch: normal;
				line-height: 36px;
				letter-spacing: 0px;
				color: #666666;
			}
			p:nth-of-type(1) {
				font-size: 40px;
				margin-bottom: 32px;
				color: #333333;
			}
		}

		.white-bg .content-box > div,
		.grey-bg .content-box > div {
			display: flex;
			flex-direction: column;
			justify-content: center;
		}

		.grey-bg {
			background: #e9eff5;
		}
		.white-bg {
			background: #ffffff;
		}
		.main-part {
			padding: 333px 0px;
			& > p:nth-of-type(1) {
				font-size: 42px;
				color: #f5f5f5;
			}
			& > p:nth-of-type(2) {
				margin-top: 10px;
				font-size: 24px;
				color: #d8e8f0;
			}
			& > div {
				margin-top: 70px;
				display: flex;
			}

			.download {
				font-size: 20px;
				color: #3385dd;
				letter-spacing: 1px;
				display: flex;
				flex-direction: column;
				p {
					padding: 10px 30px;
					border-radius: 80px;
					display: flex;
					cursor: pointer;
					align-items: center;
					background: #ffffff;
					img {
						margin-right: 24px;
					}
				}

				p:nth-of-type(2) {
					margin-top: 60px;
				}
			}

			.QRcode {
				margin-left: 50px;
				canvas {
					width: 148px !important;
					height: 148px !important;
				}
				p {
					text-align: center;
					margin-top: 8px;
					font-size: 15px;
					color: #ffffff;
				}
			}
		}

		.aboutUS {
			background: #f5f5f5;
			padding-bottom: 20px;
			.content-box p {
				text-align: center;
				margin-top: 20px;
				color: #666666;
				font-size: 15px;
			}
			.content-box p a {
				color: #666666;
				text-decoration: solid;
				text-decoration-line: underline;
			}
		}

		._info {
			display: flex;
			border-bottom: 1px solid #e8e8e8;
			padding: 25px 0px;
			box-sizing: border-box;
			height: 224px;
			& > div {
				&:nth-of-type(1),
				&:nth-of-type(2),
				&:nth-of-type(3) {
					border-right: 1px solid #e8e8e8;
				}

				&:nth-of-type(2),
				&:nth-of-type(3) {
					display: flex;
					flex-direction: column;
					align-items: center;
					a {
						text-align: center;
						margin-top: 15px;
						color: #666666;
						text-decoration: none;
					}
					p {
						text-align: center;
						font-size: 20px;
						margin-top: 0px;
						margin-bottom: 5px;
						color: #333333;
					}
				}

				&:nth-of-type(1) {
					width: 30%;
					display: flex;
					align-items: center;
				}
				&:nth-of-type(2) {
					width: 20%;
				}
				&:nth-of-type(3) {
					width: 20%;
				}
				&:nth-of-type(4) {
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
					width: 30%;
					p {
						font-size: 18px;
						letter-spacing: 0px;
						color: #666666;
					}
				}
			}
		}
	}
</style>
